import {ref, getCurrentInstance} from 'vue';
import merge from '@/funcoes/mergeObjects';
import stateUtil from '@/store/util/stateUtil.js'
import boxModuleDisposicao from "@/store/modules/boxModule_Disposicao.js";
import funcoesDistribuicao from '@/store/modules/boxModule_Distribuicao';

export default class BoxModules {

    constructor(painelModules: any) {
        this._stateUtil = new stateUtil(this);
        this._painelModules = painelModules;
        this._funcoesDisposicao = new boxModuleDisposicao(this._stateUtil, this)
    }

    app = getCurrentInstance();
    _stateUtil = null;
    _painelModules = null;
    _funcoesDisposicao = null;

    boxes = ref([]); //conterá todos boxes do painel e seus objetos
    undoStack = ref([]); //pilha de boxes para desfazer as modificações
    redoStack = ref([]); //fila de boxes utilizado para refazer as modificações
    deleteTrigger = ref(0);
    undoRedo = ref({
        undo: 0,
        redo: 0
    });
    stackSize = ref(20);
    contextMenu = ref({
        visible: false,
        lock: false,
        nodes: []
    });
    boxSelectedBound = ref(null);

    //variaveis de eventos
    visBoxMovedX = ref({
        data: null,
        handler: 0
    });
    visBoxMovedY = ref({
        data: null,
        handler: 0
    });
    visBoxCreated = ref({
        id: null,
        carregandoPainel: false, //quando carrega o painel
        handler: 0
    });
    visBoxAdded = ref({
        id: null,
        idCard: 0,
        handler: 0
    });
    visBoxFocused = ref({
        id: null,
        oldId: null,
        handler: 0
    });
    visBoxDeleted = ref({
        id: null,
        handler: 0
    });
    visBoxResized = ref({
        id: null,
        handler: 0
    });
    visBoxRequestSelection = ref({
        idx: null,
        handler: 0
    });
    visBoxObjectDevChanged = ref({
        idx: null,
        handler: 0
    })
    visBoxMouseDown = ref({
        id: null,
        handler: 0
    });
    visBoxFilterRequired = ref({
        id: null,
        fontes: [],
        ignorarComponentes: [],
        handler: 0
    });
    visBoxTabPanelTabChanged = ref({
        id: null,
        tabAnterior: 0,
        tabAtual: 0,
        handler: 0
    });
    linhasAlinhamento = ref({
        vertical: [],
        horizontal: []
    });

    fontesFiltradas = ref([]);
    
    dadosIA = ref({
        fonteDadosIA: {},
        boxSelecionado: {}
    });

    painelEnabled = () => {
        let data = this._stateUtil.getBoxesSelected();
        return data.length == 0 ? true : false

    }

    boxesSelectedCount = () => {
        let data = this._stateUtil.getBoxesSelected();
        if (data == undefined) return;
        return data.length
    }

    boxById = (id: any) => {
        return this.boxes.value.find((b: any) => b.id == id);
    }

    onVisBoxResized = () => {
        return this.visBoxResized.value;
    }

    // onVisBoxRequestSelection = () => {
    //     return this.visBoxRequestSelection.value
    // }

    // getVisBoxMouseDown = () => {
    //     return this.visBoxMouseDown.value
    // }

    onVisBoxFocused = () => {
        return this.visBoxFocused.value
    }

    onAtualizouGridPropriedades = () => {
        return this.visBoxObjectDevChanged.value
    }

    boxesByIdParent = ({idParent, idxParentTab}: any) => {
        var res = this.boxes.value.filter((b: any) => b.parent.id == idParent && b.parent.idxTab == idxParentTab);
        return res;
    }


    getIndexNoPai = (id: any) => {
        let box = this.boxes.value.find((b: any) => b.id == id)
        let boxesPai = this.boxes.value.filter((b: any) => b.parent.id == box.parent.id && b.parent.idxTab == box.parent.idxTab);
        return boxesPai.indexOf(box)
    }


    addBox = (payload: any) => {
        if (payload.creationInfo)
            console.show('creationInfo:', payload.creationInfo);

        //payload obrigatorios: type, id e pos (perc)
        let box = {};

        if (payload.creationInfo) {
            box.name = payload.creationInfo.name;
            box.icon = payload.creationInfo.icon;
            box.creationInfo = payload.creationInfo; //todos os dados informados no modal de criação do objeto
            if (payload.parent)
                box.parent = (({id, idx, idxTab}) => ({id, idx, idxTab}))(payload.parent);
        }

        let setVisBoxCreated = (val) => {
            this.visBoxCreated.value = {
                type: val.Box.type,
                id: val.Box.id,
                carregandoPainel: payload.carregandoPainel || false,
                handler: Math.random()
            }
        }

        //evento
        box = {
            //componente visbox
            __component: null,
            get component() {
                return this.__component
            },
            set component(val) {
                this.__component = val;
                setVisBoxCreated(val);
                payload.carregandoPainel = false;
            },

            componentObj: null, //componente que o visbox cria e que contem o objeto da dev
            name: "", //nome para árvore de objetos
            icon: "", //ícone para árvore de objetos

            //objeto é o componente da dev
            //  -> essa propriedade DEVE ser uma funcao que retorna a instancia do objeto, e não uma variavel contendo a instancia conforme o problema relatado no link abaixo
            //  -> ver: https://www.devexpress.com/support/center/Question/Details/T718043
            //  -> "You need to keep widget instances outside the "data" function"
            __objeto: () => null,
            get objeto() {
                return this.__objeto;
            },
            set objeto(obj) {
                this.__objeto = obj;
            },

            //utilizado pra qdo o objeto for movido, de um card pro painel ou outro local prum card: refaz os dados
            cardInfo: {
                isCard: false, //só um atalho acelerador pra saber quando é card
                idCard: null,
                firstLoad: true //primeiro carregamento do box
            },

            dadosProprios: payload.dadosProprios, //quando o componente nao possui dados da dev. ex: dbtext
            type: payload.type, //tipo de objeto da dev

            fonteDeDados: {
                idUnico: null, //guid da fonte de dados
                alias: null,
                idSQL: null,
                idRequisicaoAPI: null,
                campos: [],
                formula: null,

                top: null, //usado na funcao Top // pode-se utilizar duas funcoes, uma no formula e um valor no top e considerar programaticamente a execução da formula e a Top pelo valor
                           // no gráfico, pode ser um objeto
            },

            idx: this.boxes.value.length, //indice do objeto, em tdos os outros locais, ssa prop deve ser setada com a funcao setIdx()

            parent: {
                id: null, //id do pai, quando for na raiz, é null
                idx: -1, //indice do pai, quando for na raiz, é -1
                idxTab: -1 //quando o pai é um tabpanel, terá indice da tab
            },

            id: payload.id, //box.boxId, //string

            //div azul de movimentacao do objeto
            cornerMove: {
                active: false, //se a camada de mover objeto fica no cantinho
                position: 'right'
            },

            filter: {
                active: false, //se é um componente que filtra, ele setará isso como ativo
                //getFilters() //funcao adicionada ao final deste método
            },

            state: {
                expandido: false,
                firstLoaded: false,
                montado: false,
                moved: false,
                __selected: false,
                __selected_handle: (new Date()).getTime(), //controle do selected
                _this: this,
                get selected() {
                    return this.__selected;
                },
                set selected(value) {
                    this.__selected = value;
                    if (value)
                        this.__selected_handle = (new Date()).getTime();
                    else
                        this.focused = false;

                    //desmarca o primeiro
                    (this._this._stateUtil.getFirstSelected() || {state: {}}).state.first = false;

                    //decide o primeiro ordenando pelo handle
                    let boxes = this._this.boxes.value == undefined ? this._this.boxes : this._this.boxes.value;
                    var ordem = boxes.filter((b: any) => b.state.selected).sort(function (a: any, b: any) {
                        return (a.state.__selected_handle > b.state.__selected_handle) ? 1 : ((b.state.__selected_handle > a.state.__selected_handle) ? -1 : 0);
                    })
                    //se tiver mais de um
                    if (ordem.length > 1)
                        ordem[0].state.first = true;
                },

                first: false, //somente leitura
                focused: false,
                resizing: false,
                dragging: false,
                loading: true,

                copied: false, //marcado para cópia
                cut: false //marcado para mover
            },

            //visible não é um state, é uma propriedade fixa
            visible: true,
            visibleMobile: true,
            visibleTablet: true,
            visibleWidget: true,

            lock: false, //Bloqueia o deslocamento do obj
            window: {
                rotation: 0, //graus
                background_cor_config: payload.creationInfo ? payload.creationInfo.background : {},
                roundCorner: 0,
                showShadow: false,
                border: {
                    color_cor_config: {},
                    style: 'solid',
                    visible: ['TabPanel', 'Accordion', 'GrupoExpansivel'].includes(payload.type) ? true : false,
                    width: {
                        top: 1,
                        right: 1,
                        bottom: 1,
                        left: 1
                    }
                },
                margin: {
                    visible: false,
                    visibleMobile: false,
                    visibleTablet: false,
                    visibleWidget: false,
                    width: {
                        top: 1,
                        right: 1,
                        bottom: 1,
                        left: 1
                    }
                },
                margin_externa: {
                    visible: false,
                    visibleMobile: false,
                    visibleTablet: false,
                    visibleWidget: false,
                    width: {
                        top: 1,
                        right: 1,
                        bottom: 1,
                        left: 1
                    }
                },
                menu: {
                    showShadow: false,
                    showZoom: false,
                    comments: false,
                    exportEnabled: false,
                    floatMenu: false,
                    menuAlwaysVisible: false,
                    modelos: true,
                    info: {
                        enabled: false,
                        text: ''
                    }
                }

            },

            collision: {
                hitX: false,
                hitY: false,
                prop: '',
                //posX: 0,
                //posY: 0,
                sideX: '', //lado que colide
                sideY: '', //lado que colide
            },

            //creationInfo: payload.creationInfo, //dados informados no modal de criação do objeto

            perc: JSON.parse(JSON.stringify(payload.pos || {})), //posicao e tamanho em percentual
            percMobile: JSON.parse(JSON.stringify(payload.pos || {})), //posicao e tamanho em percentual
            percTablet: JSON.parse(JSON.stringify(payload.pos || {})), //posicao e tamanho em percentual
            percWidget: JSON.parse(JSON.stringify(payload.pos || {})), //posicao e tamanho em percentual

            pixel: {}, //posicao e tamanho em pixels
            abrirConfigModelos: false,
            salvarConfigModelos: false,

            //componente bullet
            bulletInfo: null,

            //zIndex: state.boxes.filter(b => b.parent.idx == -1).length

            _temp: { // variaveis temporarias, não precisa ser gravado em banco

            },
            ...box //se teve creationInfo
            //, ...payload.bdBox usando mergeObjects abaixo
        }
        if (payload.bdBox != undefined)
            merge.mergeObjects(box, payload.bdBox, {fullMerge: true, substituirVazios: true}) //se é um box vindo do bd, sobrescreve as propriedades padrão de um novo objeto que foram setadas acima

        //console.log('~', box.parent)

        box.cardInfo.isCard = box.type == 'Card';

        //adiciona funcionalidades
        box.filter.getFilters = () => {
            return (box.componentObj?.getFilters && box.componentObj?.getFilters()) || [];
        }
        box.getIdsFontesDados = (desconsideraFiltros:any) => {
            if (box.type === 'Mapa') {
                let arrayIdsFontes = box.componentObj?.dados?.camadas?.map((camada:any) => camada.dados.idFonte) || [];
                if (!desconsideraFiltros)
                    box.componentObj?.dados?.camadas?.forEach((camada:any) => {
                        camada.box_filter_config?.fontesDados?.forEach((fd:any) => {
                            if (fd.idUnico)
                                arrayIdsFontes.push(fd.idUnico)
                        })
                    })
                return arrayIdsFontes
            }

            let idsFonteFiltros = desconsideraFiltros ? [] : (box?.filter?.getFilters()?.map((f:any) => f.idUnico) || []);

            if (box.fonteDeDados.idUnico) {
                return [box.fonteDeDados.idUnico, ...idsFonteFiltros]
            } else { // Filtros que não tem fonte
                return idsFonteFiltros
            }
        }

        this.boxes.value.push(box);

        if (!payload.realocar)
            this.undoStack.value.push({type: 'add', estrutura: box});

        //console.show('Boxes adicionados:', _state.boxes.length)
        this.visBoxAdded.value = {
            id: payload.id,
            idCard: box.cardInfo.idCard,
            handler: Math.random()
        };

        return box;
    }

    visDeselecionarTodos() {
        let selecionados = this._stateUtil.getBoxesSelected();

        selecionados.forEach(b => {
            b.state.selected = false;
            b.state.first = false;
            b.state.resizing = false;
            b.state.dragging = false;
        })
    }


    visBoxDelete() {
        this.visBoxDeleteSelecionados();

        setTimeout(() => this._funcoesDisposicao?.visBoxReordenaBoxes(this.boxes.value), 50);

        setTimeout(() => this.visBoxAtualizaBoundSelecionados(), 50);


    }

    visBoxAtualizaBoundSelecionados() {
        this._stateUtil.calcVirtualBound();
    }

    //antes de chamar isso no box, tenha certeza que executou o "this.b_resizeHandle = Math.random();" no box, ou pode haver problema com a visibilidade da aba
    visBoxMudaPai(payload: any) {
        //{
        //   idParent: id do objeto que vai receber os selecionados
        //   idxParent: idx do objeto que vai receber os selecionados
        //   idxTab: idx da tab que no objeto que vai receber os selecionados
        //}

        //marca o novo pai
        let novoPai = this.boxes.value.find(s => s.idx == payload.idxParent);

        var selecionados = payload.objetos || this.boxesSelected();

        //filhos do nivel que vai entrar o novo box
        let filhos = this.getBoxesFilhosDiretos(payload);
        let idxTo = filhos.length ? filhos[filhos.length - 1].idx : payload.idxParent; //ultimo filho

        selecionados.forEach(b => {
            if (b.parent.id == payload.idParent && b.parent.idx == payload.idxParent && b.parent.idxTab == payload.idxTab)
                return;

            //console.log('~b.state.loading = true', b.type);

            b.state.loading = true;
            b.state.montado = false;
            // b.state.loading = true;

            //pai
            b.parent.id = payload.idParent;
            b.parent.idx = payload.idxParent;
            b.parent.idxTab = payload.idxTab;
            b.component.deselecionar();
            b.state.moved = true;


            //
            idxTo += 0.1;

            b.idxOld = b.idx; //temp do antigo index

            this._stateUtil.setIdx(b, idxTo);
        });

        this._stateUtil.ordenaBoxes();
        this._stateUtil.sequenciaBoxesIdx();
        //corrige possiveis referencias erradas ao posicionamento anterior do pai
        this.boxes.value.filter(b => b.parent.id == payload.idParent).forEach(b => b.parent.idx = (novoPai || {idx: -1}).idx);
        if (selecionados.length) {
            this.ativaAbaRecursivamente(selecionados[0].idx);
            this.visBoxAdded.value = {
                id: selecionados[0].id,
                idCard: selecionados[0].cardInfo.idCard,
                handler: Math.random()
            }
        }

        //remove a propriedade temporaria
        selecionados.forEach(b => {
            delete b.idxOld;
        });

        setTimeout(() => this.visBoxAtualizaBoundSelecionados(), 500);
    }

    ativaAbaRecursivamente(idxReferencia: any) {
        let pais = this.getBoxesPais(idxReferencia);
        pais.forEach((b: any) => {
            if (b.idxPai == -1)
                return;

            //pega a posicao da aba pelo idx (a posicao da aba pode mudar)
            //ver: abaMixin.js -> moveAbaTo
            if (['TabPanel', 'Accordion'].includes(this.boxes.value[b.idxPai].type)) {
                var abas = this.boxes.value[b.idxPai].objeto().option('items');
                var indexReal = abas.indexOf(abas.find((a: any) => a.idx == b.idxTabPai))
                this.boxes.value[b.idxPai].objeto().option('selectedIndex', indexReal);
            } else if (this.boxes.value[b.idxPai]?.type == 'GrupoExpansivel') {
                this.boxes.value[b.idxPai].componentObj.expandido = true
            }
        });
    }

    getBoxesPais(idxInicial: any) {
        let pais: any = new Set();

        //console.log('~ >> getBoxesPais')

        //funcao recursiva
        let _this = this;

        function IdentificaRecursivamenteTodosPais(indexInicial: any) {
            if (indexInicial < 0)
                return;

            pais.add(indexInicial);
            let idxPai = _this.boxes.value[indexInicial].parent.idx;
            if (idxPai == -1)
                return;

            if (indexInicial == idxPai)
                throw new Error('xabau')

            //procura pai
            //console.log('~ >>>   ', indexInicial, 'IdentificaRecursivamenteTodosPais- chamada recursiva:', state.boxes[indexInicial].type, idxPai)
            IdentificaRecursivamenteTodosPais(idxPai);
        }

        //console.log('~ >>>   Length:', state.boxes.length)
        //state.boxes.forEach(b => {
        //    console.log('~ >>>   ', b.idx, 'box:', b.type, b.name, 'parent:', b.parent.idx);
        //})
        //console.log('~ >>>   IdentificaRecursivamenteTodosPais- chamada inicial:', state.boxes[idxInicial].type, idxInicial)
        IdentificaRecursivamenteTodosPais(idxInicial);

        pais = [...pais]; //trnsforma o Set em Array
        var result: any = [];
        pais.forEach(f => {
            result.push({
                idx: f,
                idxPai: this.boxes.value[f].parent.idx,
                idxTabPai: this.boxes.value[f].parent.idxTab,
                getBox: () => this.boxes.value[f]
            })
        });

        return result;
    }

    visBoxDeleteSelecionados() {
        //se nao tiver nada, faz nada
        let boxesSelect = this.boxesSelected();

        if (!boxesSelect.length)
            return;

        let idsRemover = [];

        //passo 1 - idx dos selecionados
        var selecionados = boxesSelect.map(b => b.idx);

        //passo 2 - separa a partir do primeiro selecionado
        selecionados.forEach(s => idsRemover = idsRemover.concat(this.getBoxesFilhos(s).map(b => b.id))); //adiciona todos os selecionados, pois devem estar todos no mesmo nivel de pai

        //passo 3 - remover o separado na ordem inversa
        idsRemover = [...idsRemover];
        for (let index = idsRemover.length - 1; index >= 0; index--) {
            //Preciso do index dinâmico de acordo com que o array muda
            let idx = this.boxes.value.findIndex(b => b.id == idsRemover[index])
            //excluir do array
            this.boxes.value.splice(idx, 1);

            //evento
            this.visBoxDeleted.value = {
                idx: idsRemover[index], //string
                handler: Math.random()
            }
        }
    }
    setVisBoxFilterRequired(payload: any) {
        this.visBoxFilterRequired.value = {
            id: payload.id,
            fontes: payload.fontes,
            ignorarComponentes: payload.ignorarComponentes,
            handler: Math.random()
        };
    }
    visAtivaTabPanelRecursivamente(idx: any) {
        this.ativaAbaRecursivamente(idx);
    }
    setVisBoxRequestSelection(idx: any) {
        this.visBoxRequestSelection.value = {
            idx: idx, //string
            handler: Math.random()
        };
    }

    getBoxesFilhosDiretos(idxs: any) {
        return this._stateUtil.getBoxesFilhosDiretos(idxs.idParent, idxs.idxTab);
    }

    boxesSelected() {
        return this._stateUtil.getBoxesSelected()
    }

    getBoxesFilhos(idxInicial: any = null) {
        return this._stateUtil.getBoxesFilhos(idxInicial)
    }

    atualizaGridPropriedades(idx: any) {
        //console.trace();
        this.visBoxObjectDevChanged.value = {
            idx: idx, //string
            handler: Math.random()
        };
        if(document.activeElement instanceof HTMLElement)
            document.activeElement.blur();
    }

    setVisBoxTabPanelTabChanged(payload: any) {
        this.visBoxTabPanelTabChanged.value = {
            id: payload.id,
            tabAnterior: payload.tabAnterior,
            tabAtual: payload.tabAtual,
            handler: Math.random()
        };
    }

    setLinhasAlinhamento(payload: any): void {
        this.linhasAlinhamento.value = payload
    };

    clearBoxes() {
        this.boxes.value = [];
    };

    addFonteFiltrada(payload: any) {
        this.fontesFiltradas.value.push(payload)
    }

    removeFonteFiltrada(idUnico:any) {
        this.fontesFiltradas.value = this.fontesFiltradas.value.filter((f:any) => f.idUnico !== idUnico)
    }

    pushUndoStack(payload: any) {
        if (this.undoStack.value.length >= this.stackSize.value) // se a pilha já tiver um tamanho maior ou igual a stackSize remove o primeiro elemento
            this.undoStack.value.shift()
        this.undoStack.value.push(payload)
    }

    boxesCtrlC() {
        return this._stateUtil.getBoxesCtrlC()
    }

    boxesCtrlX() {
        return this._stateUtil.getBoxesCtrlX()
    }

    boxFirst() {
        return this._stateUtil.getFirstSelected()
    }

    setDelTrigger() {
        this.deleteTrigger.value++
    }

    boxFocused() {
        return this.boxes.value.find((b: any) => b.state.focused);
    }

    pushRedoStack(payload: any) {
        if (this.redoStack.value.length >= this.stackSize.value) // the same from above
            this.redoStack.value.shift()
        this.redoStack.value.push(payload)
    }

    ReordenaBoxes(payload: any) {
        this._funcoesDisposicao.reverterOrdem(payload)
        setTimeout(() => {
            this._funcoesDisposicao.visBoxReordenaBoxes(this.boxes.value)
        }, 500)
    }

    setContextMenu(payload: any) {
        this.contextMenu.value = payload;
    }

    setVisBoxMouseDown(id: any) {
        this.visBoxMouseDown.value = {
            id: id,
            handler: Math.random()
        };
    }

    setVisBoxResized(id: any) {
        this.visBoxResized.value = {
            id,
            handler: Math.random()
        }
    }

    clearFontesFiltradas() {
        this.fontesFiltradas.value = []
    }

    VisBoxBloqueiaSelecionados() {
        //se nao tiver nada, faz nada
        if (!this.boxesSelected().length)
            return;
        //bloqueia selecionados
        this.boxesSelected().forEach((box: any) => {
            if (box.lock) {
                box.lock = false
                return
            }
            box.lock = true
        });
    }

    visBoxMoveZIndex(tipo: any) {
        this._funcoesDisposicao.visBoxSetDisposicao(tipo)
        this._funcoesDisposicao.visBoxReordenaBoxes()
    }

    visBoxDistribuir(param: { painel: any, tipo: any }) {
        funcoesDistribuicao.visBoxDistribuir(this, param);
    }

    visBoxMove(payload: any) { //payload: {id: string, prop: ['x' ou 'y', variacao: number}
        var prop = payload.prop;
        //evento
        if (prop.toUpperCase() == "Y") {
            this.visBoxMovedY.value = {
                data: payload, //{id: string, variacao: number}
                handler: Math.random()
            }
        } else if (prop.toUpperCase() == "X") {
            this.visBoxMovedX.value = {
                data: payload, //{id: string, variacao: number}
                handler: Math.random()
            }
        }
    }

    setUndoRedo(payload: any) {
        if (payload === 'UNDO')
            this.undoRedo.value.undo++
        else if (payload === 'REDO')
            this.undoRedo.value.redo++
    }

    visBoxFocus(id: any) {
        //console.log('visBoxFocus:', id, '==', state.visBoxFocused.id, ':', id == state.visBoxFocused.id, state.boxes)
        if (id == this.visBoxFocused.value.id && this.boxes.value.find((b: any) => b.id == id).state.focused)
            return;
        this.boxes.value.forEach(b => b.state.focused = false);
        this.boxes.value.find(b => b.id == id).state.focused = true;
        //evento
        this.visBoxFocused.value = {
            id: id, //string
            oldId: this.visBoxFocused.value.id,
            handler: Math.random()
        };
    }

    VisBoxBloqueia() {
        this.VisBoxBloqueiaSelecionados();
        this.visDeselecionarTodos();
        setTimeout(() => {
        }, 500)
    }


    visBoxAlinhar(tipo: any) {
        if (!this.boxFirst()) {
            //console.log('~@@@ alinhar: nenhum first box selecionado')
            return;
        }

        if (this.boxesSelected().length < 2) {
            //console.log('~@@@ alinhar: menos de 2 boxes selecionados')
            return;
        }

        this.boxesSelected().forEach((b: any) => {
            if (b.state.first)
                return;

            switch (tipo) {
                case 'TOP': {
                    let pos = this.boxFirst().perc.y;
                    if (this._painelModules.painel.value.percAlturaDinamica() && pos + b.perc.h > this._painelModules.painel.value.percAlturaDinamica()) //evitas estouro de borda
                        pos = this._painelModules.painel.value.percAlturaDinamica() - b.perc.h;
                    b.perc.y = pos;
                    break;
                }

                case 'BOTTOM': {
                    let f = this.boxFirst().perc.y + this.boxFirst().perc.h;
                    let pos = f - b.perc.h;
                    if (pos <= 0) //evitas estouro de borda
                        pos = 0;
                    b.perc.y = pos;
                    break;
                }

                case 'LEFT': {
                    let pos = this.boxFirst().perc.x;
                    if (pos + b.perc.w > 100) //evitas estouro de borda
                        pos = 100 - b.perc.w;
                    b.perc.x = pos;
                    break;
                }

                case 'RIGHT': {
                    let f = this.boxFirst().perc.x + this.boxFirst().perc.w;
                    let pos = f - b.perc.w;
                    if (pos <= 0) //evitas estouro de borda
                        pos = 0;
                    b.perc.x = pos;
                    break;
                }

                case 'VERTICAL': {
                    let f = this.boxFirst().perc.y + (this.boxFirst().perc.h / 2);
                    let pos = f - (b.perc.h / 2)
                    if (pos <= 0) //evitas estouro de borda
                        pos = 0;
                    b.perc.y = pos;
                    break;
                }

                case 'HORIZONTAL': {
                    let f = this.boxFirst().perc.x + (this.boxFirst().perc.w / 2);
                    let pos = f - (b.perc.w / 2)
                    if (pos <= 0) //evitas estouro de borda
                        pos = 0;
                    b.perc.x = pos;
                    break;
                }
            }
        });
    }
}